// extracted by mini-css-extract-plugin
module.exports = {"recoveryModal":"RecoveryPasswordModal_recoveryModal__1Iet0","linkBtn":"RecoveryPasswordModal_linkBtn__1bLYN"};